export const validateCNPJ = (value: any): boolean => {
  if (typeof value !== 'string') return false;

  value = value.replace(/[^\d]+/g, '');

  if (value.length !== 14) return false;

  // Elimina cnpj inválidos conhecidos
  if (/^(\d)\1+$/.test(value)) return false;

  // Valida DVs
  let tamanho = value.length - 2;
  let numeros = value.substring(0, tamanho);
  let digitos = value.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = value.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
};
